<div class="container-fluid navBarInvoice">
  <app-header-form
    [title]="title"
    [panelOpenState]="panelOpenState"
    [canShowClearFilter]="true"
    [canShowPanelFilter]="true"
    [canExportExcel]="true"
    (onClearFilterEvent)="clearSearchFilter()"
    (onPanelOpenStateEvent)="onShowFilter($event)"
    (onExportAsExcelEvent)="exportAsExcel()"
    >
  </app-header-form>
</div>

<hr *ngIf="!panelOpenState">

<div class="container-fluid search-container">
  <div class="card" *ngIf="panelOpenState">
    <div class="card-body searchCard">
      <div fxLayout="row" fxLayoutGap="10px" >
        <div fxLayout="column" fxFlex="30" fxLayoutAlign="start" >
          <div fxLayout="row" class="dateStyle">
            <mat-form-field floatLabel="always" appearance="outline" fxFlex="100">
              <mat-label>Date de la facture</mat-label>
              <custom-date-range-input
              (onDateChange)="dateChangeSearch($event);"
              typeFrom="FromDate"
              [valueFrom]="fromDate"
              typeTo="ToDate"
              [valueTo]="toDate"></custom-date-range-input>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-table
  [data]="invoices"
  [tableActions]="tableActions"
  [tableIndications]="tableIndications"
  [showClearFilterButton]="true"
  [onClearFilters]="onClearFilters"
  [exportFileName]="exportFileName"
  [columnsDefinition]="columnsDefinition"
  (onRowSelectionChange)="onRowSelectionChange($event)"
  (onAllRowSelectionChange)="onAllRowSelectionChange($event)"
  [configKey]="configKey"
  [onExportExcelCaller]="onExportExcelCaller"
  [onFiltersCleared]="onFiltersCleared"
  ngDefaultControl>

    <div class="row col" mass-actions>
        <div *ngFor="let massAction of tableMassActions" class="massaction-button">
            <div *ngIf="selectedIds?.length > 0 && massAction.Filter(selectedIds)">
                <button type="button" class="btn btn-secondary btn-sm" (click)="massAction.Handler(selectedIds)">
                    <span class="material-icons" [tooltip]="massAction.Tooltip">{{massAction.Icon}}</span>
                </button>
            </div>
        </div>
    </div>
</app-table>
